import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';

interface ParkingZone {
  id: string;
  name: string;
  totalSpaces: number;
  occupiedSpaces: number;
  level: string;
  sector: string;
  status: 'available' | 'full' | 'almost-full';
}

@Component({
  selector: 'app-occupancy',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressBarModule,
    MatIconModule,
    MatChipsModule
  ],
  templateUrl: './occupancy.component.html',
  styleUrl: './occupancy.component.scss'
})
export class OccupancyComponent implements OnInit {
  parkingZones: ParkingZone[] = [];
  totalSpaces = 0;
  totalOccupied = 0;

  ngOnInit(): void {
    this.loadParkingZones();
  }

  loadParkingZones(): void {
    // Демо дані - статус заповненості по зонах
    this.parkingZones = [
      {
        id: '1',
        name: 'Зона A',
        totalSpaces: 150,
        occupiedSpaces: 142,
        level: 'Рівень 1',
        sector: 'Північний',
        status: 'almost-full'
      },
      {
        id: '2',
        name: 'Зона B',
        totalSpaces: 120,
        occupiedSpaces: 120,
        level: 'Рівень 1',
        sector: 'Південний',
        status: 'full'
      },
      {
        id: '3',
        name: 'Зона C',
        totalSpaces: 200,
        occupiedSpaces: 85,
        level: 'Рівень 2',
        sector: 'Північний',
        status: 'available'
      },
      {
        id: '4',
        name: 'Зона D',
        totalSpaces: 180,
        occupiedSpaces: 156,
        level: 'Рівень 2',
        sector: 'Південний',
        status: 'almost-full'
      },
      {
        id: '5',
        name: 'Зона E',
        totalSpaces: 100,
        occupiedSpaces: 32,
        level: 'Рівень 3',
        sector: 'Північний',
        status: 'available'
      },
      {
        id: '6',
        name: 'Зона F',
        totalSpaces: 90,
        occupiedSpaces: 78,
        level: 'Рівень 3',
        sector: 'Південний',
        status: 'almost-full'
      },
      {
        id: '7',
        name: 'VIP Зона',
        totalSpaces: 50,
        occupiedSpaces: 12,
        level: 'Рівень 1',
        sector: 'Центр',
        status: 'available'
      },
      {
        id: '8',
        name: 'Зона для інвалідів',
        totalSpaces: 20,
        occupiedSpaces: 3,
        level: 'Рівень 1',
        sector: 'Вхід',
        status: 'available'
      }
    ];

    this.calculateTotals();
  }

  calculateTotals(): void {
    this.totalSpaces = this.parkingZones.reduce((sum, zone) => sum + zone.totalSpaces, 0);
    this.totalOccupied = this.parkingZones.reduce((sum, zone) => sum + zone.occupiedSpaces, 0);
  }

  getOccupancyPercentage(zone: ParkingZone): number {
    return Math.round((zone.occupiedSpaces / zone.totalSpaces) * 100);
  }

  getTotalOccupancyPercentage(): number {
    return Math.round((this.totalOccupied / this.totalSpaces) * 100);
  }

  getAvailableSpaces(zone: ParkingZone): number {
    return zone.totalSpaces - zone.occupiedSpaces;
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'available': return '#22c55e';
      case 'almost-full': return '#fb923c';
      case 'full': return '#ef4444';
      default: return '#9ca3af';
    }
  }

  getStatusText(status: string): string {
    switch (status) {
      case 'available': return 'Доступно';
      case 'almost-full': return 'Майже заповнено';
      case 'full': return 'Повністю заповнено';
      default: return 'Невідомо';
    }
  }
}
